import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { useDeliveries } from './useDeliveries';

export const useIsDelivered = (message: DialogMessageViewModel): boolean => {
  const deliveries = useDeliveries(message);
  return deliveries.findIndex((delivery) => delivery.isDelivered) !== -1;
};
